import { render, staticRenderFns } from "./InactiveArticle.vue?vue&type=template&id=63bfb93c&scoped=true&"
import script from "./InactiveArticle.vue?vue&type=script&lang=js&"
export * from "./InactiveArticle.vue?vue&type=script&lang=js&"
import style0 from "./InactiveArticle.vue?vue&type=style&index=0&id=63bfb93c&prod&lang=scss&scoped=true&"
import style1 from "./InactiveArticle.vue?vue&type=style&index=1&id=63bfb93c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfb93c",
  null
  
)

export default component.exports